import { withInstall } from '@ideaz/utils'
import Checkbox from './src/index'

export default withInstall(Checkbox)
export * from './src/props'
